<div #svgContainer (click)="openDialog()" [innerHtml]="svgContent | safe:'html'" style="display:none;overflow:hidden;">
</div>

<p-dialog class="image-segment-dialog" styleClass="image-segment-dialog" [(visible)]="showDialog" [modal]="true"
     [baseZIndex]="10000" [header]="parseSVG(svgContent, 'title')" [draggable]="false" [resizable]="false">
     <div [innerHtml]=" svgContent | safe:'html'">
     </div>
</p-dialog>